import css from '@styled-system/css';
import { ThemeStyles } from '@honda-canada/design-system-react';

const themeStyles = new ThemeStyles();

themeStyles.addBaseStyles('IconWrapper')(() =>
  css({
    ml: 'xxs',
  }),
);

themeStyles.addBaseStyles('WalkAroundVideoCtaContainer')(() =>
  css({
    mt: 's',
  }),
);

themeStyles.addBaseStyles('WalkAroundLink')(({ theme, color }) =>
  css({
    fontSize: 'sm',
    lineHeight: '22px',
    color,
    '&:hover, &:focus': {
      borderColor: theme?.colors?.red,
    },
  }),
);

themeStyles.addBaseStyles('StyledMarkdown')(() =>
  css({
    '& > ul > li': {
      paddingBottom: '10px',
    },
  }),
);

export default themeStyles;
